<script>
export default {
  name: 'SecondaryHeading',
  props: {
    text: { type: String, required: true, default: '' },
  },
};
</script>
<template>
  <h2
    v-if="text"
    class="secondary-heading"
    v-html="text"
  />
</template>
<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.secondary-heading {
  @include cdr-text-heading-serif-600;
  padding: $cdr-space-three-quarter-x 0;
  margin: 0 0 $cdr-space-half-x;
}
</style>
